;(function() {
  'use strict'

  angular.module('core.services').factory('colorService', service)

  /* @ngInject */
  function service() {
    return {
      lighten: lighten,
      darken: darken,
      textForBg: textForBg,
    }

    function lighten(color, percent) {
      return adjustContrast(color, percent)
    }

    function darken(color, percent) {
      return adjustContrast(color, -percent)
    }

    function textForBg(backgroundColor) {
      var rgb = hexToRgb(backgroundColor)
      var o = Math.round((rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000)
      return o > 125 ? '#000000' : '#ffffff'
    }

    // function rgbToHex (r, g, b) {
    //     return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);

    //     function componentToHex (c) {
    //         var hex = c.toString(16);
    //         return hex.length === 1 ? '0' + hex : hex;
    //     }
    // }

    function hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null
    }

    function adjustContrast(color, percent) {
      var usePound = false
      if (color[0] === '#') {
        color = color.slice(1)
        usePound = true
      }

      var num = parseInt(color, 16)

      var r = (num >> 16) + percent
      if (r > 255) {
        r = 255
      } else if (r < 0) {
        r = 0
      }

      var b = ((num >> 8) & 0x00ff) + percent
      if (b > 255) {
        b = 255
      } else if (b < 0) {
        b = 0
      }

      var g = (num & 0x0000ff) + percent
      if (g > 255) {
        g = 255
      } else if (g < 0) {
        g = 0
      }

      return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16)
    }
  }
})()
